var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{staticClass:"d-inline-block w-100",attrs:{"show":_vm.loading,"rounded":"","opacity":"0.6","spinner-small":"","spinner-variant":"primary"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }